import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import XYZ from 'ol/source/XYZ';
import OSM from 'ol/source/OSM.js';
import { fromLonLat, toLonLat } from 'ol/proj';
import Overlay from 'ol/Overlay';
import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import { Icon, Style, Fill, Stroke, Circle } from 'ol/style.js';
import Vector from 'ol/Feature';
import LineString from 'ol/geom/LineString';
import Control from 'ol/control/Control';
import { defaults as defaultControls } from 'ol/control';
import { normMarkerStyle, hoverMarkerStyle, lineStyle, getHoverPopupHtml, TOStartMarkerStyle, TOEndMarkerStyle } from "./map.styles";
import Translator from "../../stdjs/translate-service";
import { createTabPage } from "../../stdjs/standard-tab-page";

var map;
var setupComplete = false;
var markerVectorSource;
var trailVectorSource;
var markerVectorLayer;
var trailVectorLayer;

var normImg = "/images/map-marker-blue.png";
var hoverImg = "/images/map-marker-red.png";

var popupContainer;
var popupContent;
var popupCloser;
var mapOverlay;

// Setup Data
export function drawBottomSection(data){
  if (!data){
    return;
  }

  const authorities = data.authorities;

  $("#orderNoTitle span").text(data.order.ORDR10_ODNO);

  drawMap(data);
  drawFullPlanning(data);
  if (authorities["*PARTS"]) {
    drawPartsTable(data);
  }
  if (authorities["*CONSIGNMENTSTATUS"]) {
    drawStatusTable(data);
  }
  
  if (authorities["*LOADINGUNITS"]) {
    drawLoadingUnits(data);
  }
  
  if (authorities["*SSCCNUMBERS"]) {
    drawSSCCNumbers(data);
  }

  createTabPage(".orderModalDetails", authorities);

  if($("#mapContainer").attr("data-map-size") === "*SMALL"){
    $(".orderModalDetails").addClass("col-10");
    $(".orderModalDetails table").removeClass("scroll");
  }

  return {
    map: map,
    vectorSource: markerVectorSource
  };
}

function drawFullPlanning(data) {
  var container = $("#fullPlanningContent");

  if (!data.fullPlanningHTML) {
    container.html("");
    return;
  }

  container.html(data.fullPlanningHTML);

  if (markerVectorSource.getFeatures().length > 0) {
    $("#fullPlanningContent .row[data-marker-id]").each(function () {
      var row = $(this);
      var stopId = row.attr("data-marker-id");
      var markers = markerVectorSource.getFeatures();
      markers.forEach(function (feature) {
        if (feature.getId() == stopId) {
          var data = feature.get("data")
          row.hover(function (e) {
            feature.setStyle(hoverMarkerStyle);
          }, function (e) {
            if (data.startMarker){
              feature.setStyle(TOStartMarkerStyle);
            } else if (data.endMarker) {
              feature.setStyle(TOEndMarkerStyle);
            } else {
              feature.setStyle(normMarkerStyle);
            }
          });
        }
      });
    });
  }

}

function drawMap(data) {

  /**
   * Initialise all the layers and sources that we need
   */
  if (!setupComplete) {
    markerVectorSource = new VectorSource();
    trailVectorSource = new VectorSource();
    markerVectorLayer = new VectorLayer();
    trailVectorLayer = new VectorLayer();
    trailVectorLayer.setSource(trailVectorSource);
    markerVectorLayer.setSource(markerVectorSource);
    markerVectorLayer.set("name", "markerLayer");
    trailVectorLayer.set("name", "trailLayer");

    popupContainer = $("#popup")[0];
    popupContent = $("#popup-content")[0];
    popupCloser = $("#popup-closer")[0];
    
    mapOverlay = new Overlay({
      element: popupContainer,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });
  }


  /**
   * Remove any existing markers or lines
   */
  markerVectorSource.clear();
  trailVectorSource.clear();

  var points = [];
  
  data.stops.forEach(function(stop, index) {
    
    /**
     * Create markers
     */
    var to = stop.to;
    var from = stop.from;

    if (from.lon != null && from.lat != null) {
      var point = new Point(fromLonLat([parseFloat(from.lon), parseFloat(from.lat)]));
      var marker = new Feature({
        name: "Marker",
        data: from,
        geometry: point,
        id: stop.from.uuid
      });
  
      marker.setId(stop.from.uuid);
      if (stop.from.startMarker) {
        marker.setStyle(TOStartMarkerStyle);
      } else {
        marker.setStyle(normMarkerStyle);
      }
      markerVectorSource.addFeature(marker);
  
      points.push([parseFloat(from.lon), parseFloat(from.lat)]);
      
      stop.gpsData.forEach(function(gpsData){
        points.push([parseFloat(gpsData.lon), parseFloat(gpsData.lat)]);
      });
    }


    if (index === data.stops.length - 1 && to.lon != null && to.lat != null) {
      var point = new Point(fromLonLat([parseFloat(to.lon), parseFloat(to.lat)]));
      var marker = new Feature({
        name: "Marker",
        data: to,
        geometry: point,
        id: stop.to.uuid
      });

      marker.setId(stop.to.uuid);
      if (stop.to.endMarker) {
        marker.setStyle(TOEndMarkerStyle);
      } else {
        marker.setStyle(normMarkerStyle);
      }
      markerVectorSource.addFeature(marker);

      points.push([parseFloat(to.lon), parseFloat(to.lat)]);
    }
    
  });
  
  /**
   * Create lines
   */
  if (points.length > 1){
    var lineString = new LineString(points);
    lineString.transform('EPSG:4326', 'EPSG:3857');
    var line = new Feature({
      geometry: lineString,
      name: "Trail"
    });
    trailVectorSource.addFeature(line);
  }
  trailVectorLayer.setSource(trailVectorSource);
  trailVectorLayer.setStyle(lineStyle);

  // var center = data.stops.length > 0 ? [data.stops[0].lon, data.stops[0].lat] : [0,0];

  /**
   * Initialse the map
   */
  if (!setupComplete) {
    $(".mapContainer").html("");
    map = new Map({
      layers: [
        new TileLayer({
          source: new OSM({
            crossOrigin: 'anonymous'
          }),
        }),
        trailVectorLayer,
        markerVectorLayer
      ],
      target: 'mapContainer',
      view: new View({
        // center: fromLonLat(center),
        zoom: 16
      }),
      overlays: [
        mapOverlay
      ]
    });

    popupCloser.click(function (e) {
      mapOverlay.setPosition(undefined);
      popupCloser.blur();
      return false;
    });

    map.on('pointermove', function (e) {
      var popupShown = false;
      if (map.hasFeatureAtPixel(e.pixel) === true) {
        var coordinate = e.coordinate;
        map.getFeaturesAtPixel(e.pixel).forEach(function (feature) {
          if (feature.get("name") === "Marker") {
            if (!popupShown) {
              feature.setStyle(hoverMarkerStyle);
              popupContent.innerHTML = getHoverPopupHtml(feature.get("data"));
              mapOverlay.setPosition(coordinate);
              // mapOverlay.setPosition(feature.getGeometry().getCoordinates());
              popupShown = true;
            }
          }
        });
      }

      if (!popupShown) {
        mapOverlay.setPosition(undefined);
        popupCloser.blur();
        markerVectorSource.forEachFeature(function (feature) {
          var data = feature.get("data")
          if (data.startMarker){
            feature.setStyle(TOStartMarkerStyle);
          } else if (data.endMarker) {
            feature.setStyle(TOEndMarkerStyle);
          } else {
            feature.setStyle(normMarkerStyle);
          }
        });
      }
    });

    /**
     * Setup button container
     */
    var buttonContainer = document.createElement("div");
    buttonContainer.className = "ol-unselectable ol-control icomoon";
    buttonContainer.style.right = ".5em";
    buttonContainer.style.top = ".5em";

    /**
     * Setup expand control
     */
    var expandButton = document.createElement("button");
    expandButton.innerHTML = "X";
    expandButton.addEventListener("click", function (e) {
      $(".orderModalDetails").removeClass("col-10");
      $(".orderModalDetails").toggle();
      $("#mapContainer").attr("data-map-size", "");
      $(showButton).hide();
      $(hideButton).hide();
      $(expandButton).hide();
      $(minimiseButton).show();
      map.updateSize();      
    });

    var minimiseButton = document.createElement("button");
    minimiseButton.innerHTML = "W";
    $(minimiseButton).hide();
    minimiseButton.addEventListener("click", function (e) {
      $(".orderModalDetails").removeClass("col-10");
      $(".orderModalDetails").toggle();
      $("#mapContainer").attr("data-map-size", "");
      $(hideButton).show();
      $(minimiseButton).hide();
      $(expandButton).show();
      map.updateSize();      
    });

    var hideButton = document.createElement("button");
    hideButton.innerHTML = "W";
    hideButton.addEventListener("click", function (e) {
      $(".orderModalDetails").addClass("col-10");
      $(".orderModalDetails table").removeClass("scroll");
      $("#mapContainer").attr("data-map-size", "*SMALL");
      $(expandButton).hide();
      $(minimiseButton).hide();
      $(hideButton).hide();
      $(showButton).show();
      map.updateSize();      
    });

    var showButton = document.createElement("button");
    showButton.innerHTML = "X";
    $(showButton).hide();
    showButton.addEventListener("click", function (e) {
      $(".orderModalDetails").removeClass("col-10");
      $(".orderModalDetails table").addClass("scroll");
      $("#mapContainer").attr("data-map-size", "");
      $(expandButton).show();
      $(showButton).hide();
      $(hideButton).show();
      map.updateSize();      
    });

    buttonContainer.appendChild(expandButton);
    buttonContainer.appendChild(minimiseButton);
    buttonContainer.appendChild(hideButton);
    buttonContainer.appendChild(showButton);

    map.addControl(new Control({
      element: buttonContainer
    }));
  
  }

  /**
   * Resize the map to fit
   */
  setTimeout(function () {
    map.updateSize();
    var source = trailVectorSource;
    if (trailVectorSource.getFeatures().length == 0){
      source = markerVectorSource;
    }
    if (source.getFeatures().length > 0) {
      map.getView().fit(source.getExtent(), {
        maxZoom: 16,
        size: map.getSize()
      });
    } else {
      map.getView().setCenter(fromLonLat([0, 0]));
      map.getView().setZoom(5);
    }
  }, 300);

  setupComplete = true;

}

export function formatRowChild(data) {
  return `
    <div id="orderDetailsSection" class="detailInline">
      <div class="bottomContainer">
        <div class="bottomItem">
          <div class="title">
              ${Translator.tr("Full Planning")}
          </div>
          <div class="content" id="fullPlanningContent">
        </div>
      </div>
      <div class="bottomItem">
          <div class="mapContainer" id="mapContainer">
          </div>
          <div id="popup" class="ol-popup">
            <a href="#" id="popup-closer" class="ol-popup-closer"></a>
            <div id="popup-content"></div>
        </div>
      </div>
      <div class="bottomItem">
          <div class="title">
              ${Translator.tr("Parts")}
          </div>
          <div class="content">
              <table id="partsTable">
                  <thead>
                      <tr>
                        <th>${Translator.tr("Part Reference")}</th>
                        <th>${Translator.tr("Description")}</th>
                        <th>${Translator.tr("Pack Type")}</th>
                        <th class="text-right">${Translator.tr("Pack Qty")}</th>
                        <th class="text-right">${Translator.tr("Actual Qty")}</th>
                      </tr>
                  </thead>
                  <tbody>
                  </tbody>
              </table>
          </div>
      </div>
    </div>
  </div>
  `;
}

function drawStatusTable(data) {
  var container = $("#consStatusContent");

  if (!data.consStatusHTML) {
    container.html("");
    return;
  }

  container.html(data.consStatusHTML);

}

function drawPartsTable(data) {
  var container = $("#partsContent");

  if (!data.partsHTML) {
    container.html("");
    return;
  }

  container.html(data.partsHTML);

}

function drawLoadingUnits(data) {
  var container = $("#loadingUnitsContent");

  if (!data.loadingUnitsHTML) {
    container.html("");
    return;
  }

  container.html(data.loadingUnitsHTML);

}

function drawSSCCNumbers(data) {
  var container = $("#ssccNumbersContent");

  if (!data.ssccNumbersHTML) {
    container.html("");
    return;
  }

  container.html(data.ssccNumbersHTML);

}